import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import { SettingService } from '../../../business-services/setting.service';
import { DealerBusinessService } from '../../../business-services/dealer.service';
import { DealerViewModel } from '../../../business-entities/dealer-view-model';
import { SelectListItemViewModel } from '../../../business-entities/select-list-item-view-model';
import { CookieService } from 'ngx-cookie-service';
import * as Enums from '../../../../../../Autofacets-Core/src/app/utils/enums';
import { UserRoleMenu } from '../../../business-entities/user-role-menu.model';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { MultiStackPopupService } from '../../../services/multi-stack-popup.service';
import { WidgetAppointmentService } from '../../../business-services/widget-appointment.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditWidgetAppointmentComponent } from '../../widget-appointment-request/edit-widget-appointment/edit-widget-appointment.component';

@Component({
  selector: 'app-widget-appointment-report',
  templateUrl: './widget-appointment-report.component.html',
  styleUrls: ['../report-dashboard.css', './widget-appointment-report.component.css']
})
export class WidgetAppointmentReportComponent implements OnInit {

  searchTerm: any;
  appliedSearchTerm: string = '';
  currency: any;
  bookedDate: any[] = [];

  dealerList: Array<SelectListItemViewModel>;
  dealerId: string = null;
  dealerSelected: string = '';

  widgetAppointmentList: any[] = [];
  serviceList: any[] = [];
  displayList: any[] = [];

  selectedBrand: any = null;
  selectedService: any = null;
  selectedSource: any = null;

  sourceList: Array<SelectListItemViewModel> = [
    { value: 'Widget Appointment', text: 'Widget Appointment' } as SelectListItemViewModel,
    { value: 'Appointment', text: 'Appointment' } as SelectListItemViewModel,
    { value: 'Archive Appointment', text: 'Archive Appointment' } as SelectListItemViewModel,
    { value: 'Deleted Widget Appointment', text: 'Deleted Widget Appointment' } as SelectListItemViewModel
  ];

  brandCounts: any = {};
  serviceItems: any[] = [];
  topCustomers: any[] = [];
  customerStats: any = {
    unique: 0, repeat: 0, repeatPercent: 0,
    consent: 0, consentPercent: 0, waiting: 0, waitingPercent: 0
  };

  brandChartLabels: string[] = [];
  brandChartData: any[] = [];
  chartPalette: string[] = [];
  dimColor: string = '';
  sliceBorderColor: string = '';
  themeColorNames: string[] = ['--primary-clr', '--orng2-clr', '--green1-clr', '--pink1-clr', '--blue7-clr'];

  doughnutOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '68%',
    plugins: {
      legend: { display: false },
      tooltip: { padding: 8, boxPadding: 4 }
    },
    onHover: (event, elements) => {
      event.native.target.style.cursor = elements.length > 0 ? 'pointer' : 'default';
    }
  };

  myDateRangePickerOptions: Partial<BsDaterangepickerConfig> = Object.assign({}, {
    containerClass: 'theme-dark-blue',
    displayMonths: 1,
    showWeekNumbers: false,
    rangeInputFormat: 'DD/MM/YYYY',
    customTodayClass: 'custom-today-class',
    maxDateRange: 366
  });

  userRoleRightsDetails: UserRoleMenu | undefined;

  constructor(
    private settingService: SettingService,
    private readonly dealerService: DealerBusinessService,
    private datePipe: DatePipe,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private cookieservice: CookieService,
    private userService: UserDataService,
    private multiStackPopupService: MultiStackPopupService,
    private service: WidgetAppointmentService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.currency = this.settingService.currencySymbol;
    this.userRoleRightsDetails = (this.userService.currentUserValue?.userRoleMenuDetails as any[])?.find(menu => menu.moduleId === Enums.ModuleNames.Appointment);
    this.setChartPalette();
    this.setDefaultDateRange();
    this.GetDealerList();
    this.getReportList();
  }

  setChartPalette() {
    let theme = getComputedStyle(document.documentElement);
    this.chartPalette = this.themeColorNames.map((name) => theme.getPropertyValue(name).trim());
    this.dimColor = theme.getPropertyValue('--grey15-clr').trim();
    this.sliceBorderColor = theme.getPropertyValue('--global-white').trim();
  }

  async GetDealerList() {
    await this.dealerService.getDealerBrandList().then((res) => {
      if (res?.dealerList) {
        this.dealerList = this.mapdealer(res.dealerList);
      }
    });
  }

  mapdealer(array: DealerViewModel[]) {
    let supperArray = [];
    if (array && array.length > 0) {
      array.forEach((element) => {
        let single = Object();
        single.value = element.dealerId;
        single.text = element.dealerName;
        supperArray.push(single);
      });
    }
    return supperArray;
  }

  onDealerSelected(dealerId: string) {
    this.dealerId = dealerId ?? null;
    this.dealerSelected = this.dealerList?.find((x) => x.value === dealerId)?.text;
    this.getReportList();
  }

  setDefaultDateRange() {
    let today = new Date();
    this.bookedDate = [
      new Date(today.getFullYear(), today.getMonth(), 1),
      new Date(today.getFullYear(), today.getMonth() + 1, 0)
    ];
  }

  onBookedDateChange() {
    if (!this.bookedDate || !this.bookedDate[0] || !this.bookedDate[1]) {
      return;
    }
    if (!this.isValidDateRange()) {
      this.toastr.error(this.translate.instant('lblMaxTwelveMonthRange'));
      this.setDefaultDateRange();
      return;
    }
    this.getReportList();
  }

  isValidDateRange(): boolean {
    let limit = new Date(this.bookedDate[0]);
    limit.setMonth(limit.getMonth() + 12);
    limit.setDate(limit.getDate() - 1);
    return new Date(this.bookedDate[1]) <= limit;
  }

  onReset() {
    this.searchTerm = null;
    this.appliedSearchTerm = '';
    this.selectedBrand = null;
    this.selectedService = null;
    this.selectedSource = null;
    this.dealerId = null;
    this.dealerSelected = '';
    this.setDefaultDateRange();
    this.getReportList();
  }

  async getReportList() {
    let model = {
      createdDateRange: this.getFormattedDate(this.bookedDate),
      customerWaiting: 0,
      dealerId: this.dealerId ? this.dealerId : '',
      LanguageCode: this.cookieservice.get('userSelectedLanguage')
    };
    this.spinner.show();
    await this.dealerService.GetWidgetServiceReport(model).then((res: any) => {
      let data = res?.responseObject;
      this.widgetAppointmentList = data?.appointments ? data.appointments : [];
      this.serviceList = data?.services ? data.services : [];
      this.setAppointmentStatus();
      this.applyFilters();
      this.buildCharts();
    }).finally(() => {
      this.spinner.hide();
    });
  }

  setAppointmentStatus() {
    this.widgetAppointmentList.forEach((item) => {
      switch (item.source) {
        case 'Widget Appointment':
          item.appointmentStatus = Enums.AppointmentType.WidgetAppointment;
          break;
        case 'Appointment':
          item.appointmentStatus = Enums.AppointmentType.Appointment;
          break;
        case 'Archive Appointment':
          item.appointmentStatus = Enums.AppointmentType.ArchiveAppointment;
          break;
        case 'Deleted Widget Appointment':
          item.appointmentStatus = Enums.AppointmentType.DeletedWidgetAppointment;
          break;
        default:
          item.appointmentStatus = null;
      }
    });
  }

  onEdit(appointment: any) {
    if(appointment.appointmentStatus === Enums.AppointmentType.DeletedWidgetAppointment){
      this.toastr.warning(this.translate.instant('lblWidgetDeletedAppointment'));
      return;
    }
    if(appointment.appointmentStatus == 1){
      this.onEditWidgetAppointment(appointment);
    }
    else{
      this.onEditAppointment(appointment);
    }
  }

  onEditAppointment(appointment: any) {
    this.multiStackPopupService.OpenAppointment(appointment.id, false);
  }

  onEditWidgetAppointment(appointment: any) {
      this.service.widgetAppointment = appointment;
      const modalref = this.modalService.open(EditWidgetAppointmentComponent, {
        size: 'lg',
        windowClass: 'EditPopup',
      });
      modalref.result.then(
        (response) => {
          if (response.success) {
            
          }
        }
      );
    }

  getFormattedDate(dateRangeArray: any[]): string {
    let formattedDate: string = '';
    if (dateRangeArray && dateRangeArray.length != 0) {
      let beginDate = this.datePipe.transform(dateRangeArray[0], 'dd/MM/yyyy');
      let lastDate = this.datePipe.transform(dateRangeArray[1], 'dd/MM/yyyy');
      formattedDate = beginDate + ' - ' + lastDate;
    }
    return formattedDate;
  }

  get totalCount(): number {
    return this.displayList ? this.displayList.length : 0;
  }

  get totalServiceCost(): number {
    return this.displayList
      ? this.displayList.reduce((sum, item) => sum + (item.price ? item.price : 0), 0)
      : 0;
  }

  onBrandChartClick(e: any) {
    if (!e || !e.active || e.active.length === 0) {
      return;
    }
    this.selectBrand(this.brandChartLabels[e.active[0].index]);
  }

  selectBrand(brand: string) {
    this.selectedBrand = this.selectedBrand === brand ? null : brand;
    this.refreshView();
  }

  selectService(service: string) {
    this.selectedService = this.selectedService === service ? null : service;
    this.refreshView();
  }

  clearFilter(isBrand: boolean) {
    if (isBrand) {
      this.selectedBrand = null;
    } else {
      this.selectedService = null;
    }
    this.refreshView();
  }

  refreshView() {
    this.applyFilters();
    this.buildCharts();
  }

  onQuickSerch() {
    let term = this.searchTerm ? this.searchTerm.toString().trim() : '';
    this.appliedSearchTerm = term.length > 5 ? term : '';
    this.applyFilters();
  }

  onSourceSelected() {
    this.applyFilters();
  }

  applyFilters() {
    let term = this.appliedSearchTerm.toLowerCase();
    this.displayList = this.widgetAppointmentList.filter((item) =>
      (!this.selectedBrand || item.brand === this.selectedBrand) &&
      (!this.selectedService || this.hasService(item, this.selectedService)) &&
      (!this.selectedSource || item.source === this.selectedSource) &&
      (!term || this.isSearchMatch(item, term)));
    this.buildCustomerInsights();
  }

  buildCustomerInsights() {
    let map: any = {};
    this.displayList.forEach((item) => {
      let key = (item.email ? item.email : item.customerName + '|' + item.mobile)
        .toString().toLowerCase().trim();
      if (!map[key]) {
        let single = Object();
        single.name = item.customerName;
        single.email = item.email;
        single.mobileCode = item.customerMobileCode;
        single.mobile = item.mobile;
        single.count = 0;
        single.amount = 0;
        map[key] = single;
      }
      map[key].count = map[key].count + 1;
      map[key].amount = map[key].amount + (item.price ? item.price : 0);
    });

    let customers = Object.keys(map).map((key) => map[key]);
    let total = this.displayList.length;
    let repeat = customers.filter((item) => item.count > 1).length;
    let consent = this.displayList.filter((item) => item.isMarketingConsent).length;
    let waiting = this.displayList.filter((item) => item.isCustomerWaiting).length;

    this.customerStats = {
      unique: customers.length,
      repeat: repeat,
      repeatPercent: customers.length ? Math.round((repeat / customers.length) * 100) : 0,
      consent: consent,
      consentPercent: total ? Math.round((consent / total) * 100) : 0,
      waiting: waiting,
      waitingPercent: total ? Math.round((waiting / total) * 100) : 0
    };

    let highest = 1;
    customers.forEach((item) => {
      highest = item.count > highest ? item.count : highest;
    });
    this.topCustomers = customers
      .sort((a, b) => b.count - a.count || b.amount - a.amount)
      .slice(0, 6)
      .map((item) => {
        let single = Object();
        single.name = item.name;
        single.email = item.email;
        single.mobileCode = item.mobileCode;
        single.mobile = item.mobile;
        single.count = item.count;
        single.amount = item.amount;
        single.percent = Math.round((item.count / highest) * 100);
        single.initials = this.getInitials(item.name);
        return single;
      });
  }

  getInitials(name: string): string {
    if (!name) {
      return '?';
    }
    let parts = name.toString().trim().split(/\s+/);
    let first = parts[0] ? parts[0].charAt(0) : '';
    let last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : '';
    return (first + last).toUpperCase();
  }

  hasService(item: any, service: string): boolean {
    return item.serviceNames
      ? item.serviceNames.split(',').some((name) => name.trim() === service)
      : false;
  }

  isSearchMatch(item: any, term: string): boolean {
    return [item.model, item.customerName, item.email, item.address]
      .some((value) => value && value.toString().toLowerCase().indexOf(term) > -1);
  }

  buildCharts() {
    this.brandCounts = this.groupCount('brand');
    this.brandChartLabels = Object.keys(this.brandCounts);
    this.brandChartData = [{
      data: this.brandChartLabels.map((key) => this.brandCounts[key]),
      backgroundColor: this.brandChartLabels.map((key, i) => this.getSliceColor(key, i)),
      borderColor: this.sliceBorderColor,
      borderWidth: 2,
      hoverOffset: 6
    }];

    let highestAmount = 1;
    this.serviceList.forEach((item) => {
      highestAmount = item.salesPriceAmount > highestAmount ? item.salesPriceAmount : highestAmount;
    });
    this.serviceItems = this.serviceList
      .map((item) => ({
        name: item.serviceName,
        count: item.totalCount,
        amount: item.salesPriceAmount,
        amountInclVAT: item.salesPriceAmountInclVAT,
        percent: Math.round((item.salesPriceAmount / highestAmount) * 100)
      }))
      .sort((a, b) => b.amount - a.amount);
  }

  getSliceColor(label: string, index: number): string {
    if (this.selectedBrand && this.selectedBrand !== label) {
      return this.dimColor;
    }
    return this.chartPalette[index % this.chartPalette.length];
  }

  groupCount(key: string): any {
    let map: any = {};
    this.widgetAppointmentList.forEach((item) => {
      let name = item[key] ? item[key] : 'Other';
      map[name] = (map[name] ? map[name] : 0) + 1;
    });
    return map;
  }

}
